export default {
  name: 'sanity.imageHotspot',
  title: 'Image hotspot',
  type: 'object',
  fields: [
    {
      name: 'x',
      type: 'number',
    },
    {
      name: 'y',
      type: 'number',
    },
    {
      name: 'height',
      type: 'number',
    },
    {
      name: 'width',
      type: 'number',
    },
  ],
}
